var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ECF9D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.2632C21.3856 10.2598 22.6814 9.62695 24.125 9.62695C26.7944 9.62695 28.9583 11.7909 28.9583 14.4603C28.9583 17.1297 26.7944 19.2936 24.125 19.2936C22.6814 19.2936 21.3856 18.6607 20.5 17.6573M24.125 31.377H9.625V30.1686C9.625 26.1646 12.8709 22.9186 16.875 22.9186C20.8791 22.9186 24.125 26.1646 24.125 30.1686V31.377ZM24.125 31.377H31.375V30.1686C31.375 26.1646 28.1291 22.9186 24.125 22.9186C22.8045 22.9186 21.5664 23.2717 20.5 23.8885M21.7083 14.4603C21.7083 17.1297 19.5444 19.2936 16.875 19.2936C14.2056 19.2936 12.0417 17.1297 12.0417 14.4603C12.0417 11.7909 14.2056 9.62695 16.875 9.62695C19.5444 9.62695 21.7083 11.7909 21.7083 14.4603Z",
    stroke: "#203202",
    strokeWidth: 1.81306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.fbda07ba418078d8833faaad14287b77.svg";
export { ForwardRef as ReactComponent };